import React from 'react';
import {
  BlockRow,
  LocationText,
  ScheduleAndLocationBlockContainer,
  ScheduleText
} from './styled';
import ScheduleIcon from '../../../../public/static/images/item/schedule.svg';
import LocationIcon from '../../../../public/static/images/item/location.svg';
import Icon from '../../../Icon';
import useToggle from '../../../../hooks/useToggle';
import { MapModal } from '../../../ui/MapModal';
import { Map } from '../../../ui/MapModal/Map';

interface ScheduleAndLocationBlockProps {
  schedule?: string | null;
  address?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  city?: string | null;
}

export const ScheduleAndLocationBlock: React.FC<
  ScheduleAndLocationBlockProps
> = ({ schedule, address, latitude, longitude, city }) => {
  const [isOpenModal, toggleModal] = useToggle(false);

  const coordinates =
    latitude && longitude ? { lat: latitude, lng: longitude } : undefined;
  const preparedAddress = [city, address].filter(Boolean).join(', ');

  return (
    <ScheduleAndLocationBlockContainer>
      <BlockRow>
        <Icon
          indent={false}
          height={18}
          width={18}
          IconComponent={ScheduleIcon}
        />
        <ScheduleText tag="body_3">{schedule}</ScheduleText>
      </BlockRow>

      <BlockRow>
        <Icon
          indent={false}
          height={18}
          width={15}
          IconComponent={LocationIcon}
        />
        <LocationText
          tag="body_3"
          onClick={coordinates ? toggleModal : undefined}
          data-stat="agency-address"
          $isCoordinates={!!coordinates}
        >
          {preparedAddress}
        </LocationText>
      </BlockRow>

      <MapModal
        isOpen={isOpenModal}
        onClose={toggleModal}
        modalId="schedule-location-map-modal"
      >
        <Map
          isOpen={isOpenModal}
          coordinates={coordinates}
          initialLocation={coordinates}
          pinSelected={isOpenModal}
          isMarkerDraggable={false}
        />
      </MapModal>
    </ScheduleAndLocationBlockContainer>
  );
};
